//////// GHG 3.15 EF
const threeFifteenSchema = {
  title: "3.15 Investments",
  cat: "5_4",
  catName: "cat5",
  progressiveOrderSwitch: {},
  fields: [
    {
      key: "title",
      type: "title",
      title: "Emission Factor",
    },
    //////Data Source
    {
      key: "emissionFactorTypeId",
      level: 1,
      type: "select",
      label: "Data Source",
      optionsAPI: "emissionFactorDropdown6_1",
      autoFillNum: 0,
    },
    ////////Emission Factor Name (自定義)
    {
      key: "emissionFactorId",
      addBtn: true,
      level: 2,
      type: "select",
      custom: true,
      label: "Emission Factor Name",
      optionsAPI: "cat5CustomEFDropdownList",
      showIf: {
        level: 1,
        key: "emissionFactorTypeId",
        eq: "2",
      },
      autoFillNum: 0,
    },
  ],
};

export default threeFifteenSchema;
